import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(private http: HttpClient) { }
  public blogId: any;
  public blogPdf: any;
  public requestAPIurl: any = environment.apiURL;
  public userId: any;
  public headers: any;


  setHeaders() {
    if (JSON.parse(sessionStorage.getItem('logged-in-user'))) {
      this.userId = JSON.parse(sessionStorage.getItem('logged-in-user'))._id;
      this.headers = new HttpHeaders().set('id', this.userId);
    }
  }

  addBlog(payload: any) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/blogs/add`, payload);
  }

  getBlog(type) {
    return this.http.get(`${this.requestAPIurl}/api/blogs/all?page=${type}`);
  }

  getBlogPdf(id) {
    return this.http.get(`${this.requestAPIurl}/api/blogs/${id}`)
  }

  deleteBlog(blogId) {
    this.setHeaders();
    return this.http.delete(`${this.requestAPIurl}/api/blogs/${blogId}`, {headers: this.headers});
  }
}
